import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { withRouter } from 'react-router-dom';
import { Collapse, Container, Nav, NavLink, Navbar, NavbarBrand, NavbarToggler } from 'reactstrap';
import { compose, mapProps, pure, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import logo from '../../../images/Zouk-Unite-logo.png';
import actions from '../../../state/actions';
import { withOnScroll, withScrollEventListener } from '../../higher-order';
import './admin-nav.css';

const AdminNav = ({
  classes,
  links,
  isOpen,
  toggle
}) => (
    <Navbar
      className={classNames(classes, { isOpen })}
      expand='md'
      dark
      fixed='top'>
      <Container fluid>
        <LinkContainer to={routes.adminPortal.root} className='waves-effect waves-light'>
          <NavbarBrand>
            <img src={logo} alt='ZoukUnite' />
          </NavbarBrand>
        </LinkContainer>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar timeout={0} enter={false} exit={false}>
          <Nav className='mr-auto' navbar>
            {
              fp.flow(
                fp.map(([key, value]) => ({
                  key,
                  link: fp.startCase(key),
                  to: typeof (value) === 'string' ?
                    value :
                    value.to,
                  exact: typeof (value) === 'string' ?
                    true :
                    value.exact
                })),
                fp.map((link) => (
                  <LinkContainer key={link.key} to={link.to} exact={link.exact}>
                    <NavLink>{link.link}</NavLink>
                  </LinkContainer>
                ))
              )(fp.toPairs(links))
            }
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );

export default compose(
  withRouter,
  connect(({ navbar: { appNav: { collapse, isOpen } } }) => ({
    collapse,
    isOpen
  }), (dispatch) => ({
    setCollapse: bindActionCreators(actions.appNav.setCollapse, dispatch),
    toggle: bindActionCreators(actions.appNav.toggleIsOpen, dispatch)
  })),
  withProps(() => ({
    links: {
      artists: {
        to: routes.adminPortal.artists,
        exact: false
      },
      events: {
        to: routes.adminPortal.events,
        exact: false
      }
    }
  })),
  withOnScroll(({ setCollapse }) => setCollapse(window.pageYOffset > 50)),
  withScrollEventListener,
  mapProps(({ classes, collapse, isOpen, ...props }) => ({
    ...props,
    collapse,
    isOpen,
    classes: {
      ...classes,
      'admin-nav': true,
      'scrolling-navbar': true,
      'top-nav-collapse': collapse
    }
  })),
  pure
)(AdminNav);



// WEBPACK FOOTER //
// ./src/components/partials/admin-nav/admin-nav.js